export class Form {

	constructor() {
		this.selectedFiles = new Map()
		this.init()
	}

	init() {
		document.addEventListener('DOMContentLoaded', () => this.initFileInputs())

		if (document.readyState !== 'loading') {
			this.initFileInputs()
		}

		this.initAgreeCheckbox()
	}

	initFileInputs() {
		const fileInputs = document.querySelectorAll('input[type="file"]')
		fileInputs.forEach(input => {
			input.addEventListener('change', (e) => {
				this.handleFileSelect(e.target)
			})
		})
	}

	initAgreeCheckbox() {
		const agreeCheckbox = document.getElementById('agreeCheckbox')
		const submitButton = document.getElementById('submitButton')

		if (agreeCheckbox && submitButton) {
			agreeCheckbox.addEventListener('change', () => {
				submitButton.disabled = !agreeCheckbox.checked
			})
		}
	}

	handleFileSelect(input) {
		const fileList = input.parentNode.querySelector('.fileList')
		const newFiles = Array.from(input.files)

		// Получаем уже добавленные ранее
		let existing = this.selectedFiles.get(input) || []

		// Объединяем и убираем дубликаты по name + size
		const merged = [...existing, ...newFiles].filter((file, index, self) => {
			return index === self.findIndex(f => f.name === file.name && f.size === file.size)
		})

		this.selectedFiles.set(input, merged)

		// Перерисовываем список
		fileList.innerHTML = ''
		for (let file of merged) {
			const li = document.createElement('li')
			li.className = 'fileItem'
			li.innerHTML = `
				<span>${file.name}</span>
				<a class="deleteButton" data-file-name="${file.name}" data-file-size="${file.size}">
					<svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1 1L13 13M13 1L1 13" stroke="Black" stroke-linecap="round"/>
					</svg>
				</a>
			`
			fileList.appendChild(li)
		}

		// Назначаем обработчики удаления
		fileList.querySelectorAll('.deleteButton').forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.preventDefault()
				this.deleteFile(btn, input)
			})
		})

		// Очищаем input, чтобы можно было выбрать тот же файл снова
		input.value = ''
	}

	deleteFile(deleteButton, input) {
		const name = deleteButton.getAttribute('data-file-name')
		const size = Number(deleteButton.getAttribute('data-file-size'))

		let files = this.selectedFiles.get(input) || []
		files = files.filter(f => !(f.name === name && f.size === size))
		this.selectedFiles.set(input, files)

		// Обновим отображение
		this.handleFileSelect(input)
	}

	submitForm(event) {
		event.preventDefault()

		const form = event.target
		const formData = new FormData()
		const submitButton = form.querySelector('#submitButton')
		const agreeCheckbox = document.getElementById('agreeCheckbox')

		if (!agreeCheckbox || !agreeCheckbox.checked) {
			alert('Необходимо согласиться с условиями обработки персональных данных')
			return false
		}

		submitButton.disabled = true
		submitButton.textContent = 'Отправка...'

		for (let el of form.elements) {
			if (!el.name) continue

			if (el.type === 'text' && el.value.trim() !== '') {
				formData.append(el.name, el.value.trim())

			} else if (el.type === 'checkbox' && el.checked) {
				const key = el.name + '[]'
				if (formData.has(key)) {
					const prev = formData.get(key)
					formData.set(key, prev + ',' + el.value)
				} else {
					formData.append(key, el.value)
				}

			} else if (el.type === 'radio' && el.checked) {
				formData.append(el.name, el.value)

			} else if (el.nodeName === 'TEXTAREA' && el.value.trim() !== '') {
				formData.append(el.name, el.value.trim())

			} else if (el.type === 'file') {
				const files = this.selectedFiles.get(el)
				if (files && files.length > 0) {
					for (let i = 0; i < files.length; i++) {
						formData.append(el.name + '_files[]', files[i])
					}
				}
			}
		}

		formData.append('action', 'submit_form')

		const xhr = new XMLHttpRequest()
		xhr.responseType = 'json'

		xhr.onload = () => {
			submitButton.disabled = false
			submitButton.textContent = 'Отправить'

			if (xhr.status === 200) {
				const response = xhr.response
				if (response && response.success) {
					const successMessage = document.getElementById('success-message')
					if (successMessage) {
						successMessage.style.display = 'block'
						form.style.display = 'none'
						
						// Скроллим к блоку с сообщением об успехе
						successMessage.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						})
					}
				} else {
					alert('Ошибка при отправке: ' + (response?.error || 'Неизвестная ошибка'))
				}
			} else {
				alert('Ошибка сети. Попробуйте повторить запрос позднее.')
			}
		}

		xhr.onerror = () => {
			submitButton.disabled = false
			submitButton.textContent = 'Отправить'
			alert('Ошибка сети. Попробуйте повторить запрос позднее.')
		}

		xhr.open('POST', '/ajax.php?mid=2')
		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
		xhr.send(formData)

		return false
	}

	loadAnketa(a) {
		$.ajax({
			url: '/ajax.php?mid=1',
			type: 'POST',
			data: {
				action: 'load',
				id: a.id,
				name: a.name,
			},
			dataType: 'json',
			success: function (res) {
				if (res.success) {
					a.childNodes[1].innerHTML = 'Скачать анкету!'
					a.href = '/mod_files/' + a.name + '-download.docx'
					a.removeAttribute('onclick')
				} else {
					alert('Ajax Error ' + res.error)
				}
			},
			error: function (err) {
				alert('Ошибка! Попробуйте повотрить запрос позднее. Error: ' + err)
			}
		})
	}
}
